export default {
  actionType: {
    navigate: 'Page Navigation',
    scan: 'Scan QR Code',
    dialog: 'Show Popup',
    custom: 'Custom URL',
  },
  end: {
    member: 'Member Center',
    mall: 'Points Mall',
    h5Scan: 'H5 Scan',
  },
  link: {
    home: 'Home',
    scan: 'Scan Verification',
    myGifts: 'My Gifts',
    myPointOrders: 'Points Orders',
    afterSale: 'After-Sales',
    growth: 'Growth Details',
    benefits: 'Membership Benefits',
    login: 'Login',
  },
  guard: {
    login: 'Requires Login',
  },
  extra: {
    params: 'Params',
    dialogTitle: 'Dialog Title',
    dialogContent: 'Dialog Content',
  },
};
